import { MessengerQrButtonComponent } from './sidebar/messenger-qr-button.component';
import { NgModule } from "@angular/core";
import { CdkTrapFocus } from "@angular/cdk/a11y";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { MatTooltipModule } from "@angular/material/tooltip";
import { TranslateModule } from "@ngx-translate/core";
import { HeaderComponent } from "./header/header.component";
import { FooterComponent } from "./footer/footer.component";
import { SidebarComponent } from "./sidebar/sidebar.component";
import { SidebarIconComponent } from "./sidebar/sidebar-icon/sidebar-icon.component";
import { DropdownUserComponent } from "../shared/dropdown-user/dropdown-user.component";
import { SharedModule } from "../shared/shared.module";
import { GlobalSearchComponent } from "../components/standalones/global-search/global-search.component";
import { AnnouncementInboxButtonComponent } from "../shared/announcement-modal/announcement-inbox-button.component";
import { StoreStatusButtonComponent } from "../shared/store-status-button/store-status-button.component";
import { HeaderGuideButtonComponent } from "../features/onboarding/components/header-guide-button/header-guide-button.component";

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
  ],
  exports: [FooterComponent, HeaderComponent, SidebarComponent, DropdownUserComponent],
  imports: [
    CdkTrapFocus,
    CommonModule,
    FormsModule,
    MatTooltipModule,
    RouterLink,
    RouterLinkActive,
    TranslateModule,
    SharedModule,
    SidebarIconComponent,
    DropdownUserComponent,
    GlobalSearchComponent,
    AnnouncementInboxButtonComponent,
    HeaderGuideButtonComponent,
    StoreStatusButtonComponent,
    MessengerQrButtonComponent,
  ],
})
export class LayoutModule {}
